export default "__VITE_ASSET__CchXSkPt__"